import { visualEntities } from "../entities.js";
import { create } from "../helpers/elements.helper.js";
import { VisualSuperHtml } from "./visual-super.environment.js";

class CanvasHtml extends VisualSuperHtml {
  setProps(eNode) {
    const canvas = document.createElement("canvas");
    eNode.element = create(eNode, canvas);

    super.setProps(eNode);
  }
}

const canvasHtml = new CanvasHtml("visual:canvas");
visualEntities.set("visual:canvas", canvasHtml);
export { CanvasHtml, canvasHtml };
